export namespace ShellHelpers {
    export const isLoggedIn = ko.pureComputed(() => !settings.requireAPassword() || settings.isLoggedIn());
}